import { sprintf } from 'sprintf-js';
import { StorageKeys } from '../../../utils/constants';
import { ILocalStorage } from '../../storage/interfaces';
import { ILanguageService } from './interfaces';
import { BehaviorSubject } from 'rxjs';
import translations from '../constants/dictionary.json';
import { returnIfDefined } from '@utils/functions';
import languagesAndCountries from '../constants/languagesAndCountries.json';

class LanguageService implements ILanguageService {
  currentLanguage: BehaviorSubject<string>;
  availableLanguages = Object.keys(translations);

  constructor(private persistentStorage: ILocalStorage) {
    this.currentLanguage = new BehaviorSubject(this.persistentStorage.get(StorageKeys.LANGUAGE) || 'en');
  }

  setLanguage(lang: string): void {
    this.persistentStorage.set(StorageKeys.LANGUAGE, lang);
    this.currentLanguage.next(lang);
  }

  translate(key: string, ...additionalArguments: any[]): string {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const dictionary = translations[this.currentLanguage.value];
    if (!dictionary) return `*${key}`;
    const translatedWord = dictionary[key];
    if (!translatedWord) return `*${key}`;
    // Для строк, которые использовались на старом сайте. Формат отличается от формата sprintf.
    if (translatedWord.includes('%@')) return translatedWord.replace('%@', additionalArguments[0]);
    let res = '';
    try {
      res = sprintf(translatedWord, ...additionalArguments);
    } catch (e) {
      console.log(translatedWord, e);
    }
    return res;
  }

  getAvailableLanguages(): string[] {
    return this.availableLanguages;
  }

  languageToCountryCode(language: string) {
    return returnIfDefined<string | undefined>(
      languagesAndCountries[language as keyof typeof languagesAndCountries]
    );
  }
}

export default LanguageService;
